module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "mint-tab-item",
    class: _vm.itemClassObject,
    on: {
      "click": function($event) {
        _vm.$parent.$emit('input', _vm.id)
      }
    }
  }, [_c('div', {
    staticClass: "mint-tab-item-icon"
  }, [_vm._t("icon", [(_vm.icontype) ? _c('i', {
    staticClass: "iconfont",
    class: [_vm.$parent.value === _vm.id ? 'mt-color-theme' : 'mt-color-grey-lv3', 'icon-' + _vm.icontype],
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "mint-tab-item-label",
    class: [_vm.$parent.value === _vm.id ? 'mt-color-theme' : _vm.labelClassObject]
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("badge")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56d90fca","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/tab-item/src/tab-item.vue
// module id = 214
// module chunks = 0